import script from "./AssessmentIpc.vue?vue&type=script&setup=true&lang=js"
export * from "./AssessmentIpc.vue?vue&type=script&setup=true&lang=js"

import "./AssessmentIpc.vue?vue&type=style&index=0&id=6a285388&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6a285388"]])

export default __exports__